var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26648 11.5333H12.2665L14.6003 7.32607C14.712 7.12484 14.924 7 15.1541 7H24.8459C25.076 7 25.288 7.12484 25.3997 7.32607L27.7335 11.5333H31.7335C34.0898 11.5333 36 13.4435 36 15.7998V30.7335C36 33.0898 34.0898 35 31.7335 35H8.26648C5.91017 35 4 33.0898 4 30.7335V15.7998C4 13.4435 5.91017 11.5333 8.26648 11.5333ZM8.26648 8.53333H10.5L11.9769 5.87083C12.6174 4.71625 13.8338 4 15.1541 4H24.8459C26.1662 4 27.3826 4.71625 28.0231 5.87082L29.5 8.53333H31.7335C35.7467 8.53333 39 11.7866 39 15.7998V30.7335C39 34.7467 35.7467 38 31.7335 38H8.26648C4.25331 38 1 34.7467 1 30.7335V15.7998C1 11.7866 4.25331 8.53333 8.26648 8.53333ZM25 21.5C25 23.9853 22.9853 26 20.5 26C18.0147 26 16 23.9853 16 21.5C16 19.0147 18.0147 17 20.5 17C22.9853 17 25 19.0147 25 21.5ZM28 21.5C28 25.6421 24.6421 29 20.5 29C16.3579 29 13 25.6421 13 21.5C13 17.3579 16.3579 14 20.5 14C24.6421 14 28 17.3579 28 21.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2729ed9ae4cf6e54dc16160d5abe47df.svg";
export { ForwardRef as ReactComponent };